import { PossibleAnswer } from '@amzn/awscat-portfolio-assessment-types';
import { Button, Input, Table, TableProps } from '@amzn/awsui-components-react';

import { constants } from '../../../common/Localization';
import { deepCopy } from '../../../common/util';

interface Props {
    possibleAnswers: PossibleAnswer[];
    addPossibleAnswer: () => void;
    deletePossibleAnswer: (possibleAnswer: PossibleAnswer) => void;
    updatePossibleAnswers: (possibleAnswers: PossibleAnswer[]) => void;
}

function DataCollectionEditPossibleAnswers({ possibleAnswers, addPossibleAnswer, deletePossibleAnswer, updatePossibleAnswers }: Props): JSX.Element {

    const updateAnswer = (currentItem: PossibleAnswer, newLabel?: string, newValue?: string) => {
        const answerIndex = possibleAnswers.findIndex(answer => answer === currentItem);
        if (answerIndex !== undefined && answerIndex > -1) {
            const updatedPossibleAnswers: PossibleAnswer[] = deepCopy(possibleAnswers);
            if (newLabel) {
                updatedPossibleAnswers[answerIndex].label = newLabel;
            } else if (newValue) {
                updatedPossibleAnswers[answerIndex].value = newValue;
            }
            updatePossibleAnswers(updatedPossibleAnswers);
        }
    };

    const columDefs: TableProps.ColumnDefinition<PossibleAnswer>[] =[
        {
            id: 'label',
            header: constants.LABEL,
            cell: item => <Input value={item.label} onChange={({ detail }) => updateAnswer(item, detail.value, undefined) } />
        },
        {
            id: 'value',
            header: constants.VALUE,
            cell: item => <Input value={item.value} onChange={({ detail }) => updateAnswer(item, undefined, detail.value) } />
        },
        {
            id: 'remove',
            header: <Button iconName='add-plus' variant='link' onClick={addPossibleAnswer}></Button>,
            cell: item => <Button iconName='close' variant='link' onClick={() => deletePossibleAnswer(item)}></Button>
        }
    ];

    return (
        <Table
            items={possibleAnswers}
            columnDefinitions={columDefs}
        />
    );
}

export default DataCollectionEditPossibleAnswers;
